module.exports = __webpack_public_path__ + "img/new_banner_workts_jz.26fa730f.png";